module.exports = __webpack_public_path__ + "img/img (51).600b93f8.png";